import { IoHome, IoHomeOutline, IoNotifications, IoNotificationsOutline, IoPerson, IoPersonOutline, IoReceipt, IoReceiptOutline, IoTicket, IoTicketOutline } from "react-icons/io5";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Post } from '../compornents/Post';
// アイコンは Ionicons v5 に統一（非選択=outline / 選択=filled）。
// 以前は Md/Io/Go/Bi の4ファミリー混在で線の太さ・形がバラついていた。

// タブ定義（1か所で管理）
const TABS = [
  { key: 'home', label: 'ホーム', Icon: IoHomeOutline, IconActive: IoHome },
  { key: 'notifications', label: 'お知らせ', Icon: IoNotificationsOutline, IconActive: IoNotifications, badge: 'new_notifications_qty' },
  { key: 'coupon', label: 'クーポン', Icon: IoTicket, IconActive: IoTicket, badge: 'unused_coupon_qty', raised: true },
  { key: 'orders', label: '注文履歴', Icon: IoReceiptOutline, IconActive: IoReceipt, badge: 'new_comment_qty' },
  { key: 'account', label: 'アカウント', Icon: IoPersonOutline, IconActive: IoPerson },
];

export const Tabbar = ({ menu }) => {
  const navigate = useNavigate();
  const [customer, setCustomer] = useState({});

  const selectMenu = (key) => navigate("/" + key);

  useEffect(() => {
    let unmounted = false;
    (async () => {
      const response_data = await Post('post', '/customer/index.php', {});
      if (response_data.result === 1 && !unmounted) {
        setCustomer(response_data.customer);
      }
    })();
    return () => { unmounted = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <nav className="tabbar" aria-label="メインナビゲーション">
      <div className="menu_list">
        {TABS.map(({ key, label, Icon, IconActive, badge, raised }) => {
          const isActive = menu === key;
          const count = badge ? Number(customer[badge]) : 0;
          const Glyph = isActive ? IconActive : Icon;
          const cls = ["menu", "text-center"];
          if (isActive) cls.push("active");
          if (raised) cls.push("raised");
          return (
            <button
              type="button"
              key={key}
              className={cls.join(" ")}
              aria-current={isActive ? "page" : undefined}
              aria-label={label}
              onClick={() => selectMenu(key)}
            >
              <div className="menu_icon_wrap">
                <Glyph className="menu_glyph" aria-hidden="true" />
                {count > 0 && (
                  <span className="menu_badge" aria-label={`${label} ${count}件`}>{count}</span>
                )}
              </div>
              <small className="menu_label">{label}</small>
            </button>
          );
        })}
      </div>
    </nav>
  );
};
